export function Checkmark(props) {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2854 0.928711L4.39248 6.82166L1.71387 4.14305"
        stroke="currentColor"
        strokeWidth="1.60714"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
